import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { inyectarTokens } from './ui/tokens';
import './ui/base.css';
import { App } from './App';

inyectarTokens();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
